import gql from 'graphql-tag';

export default gql`
  mutation AnalyzeIngredient($input: DailyTrackerAnalyzeIngredientInputType!) {
    dailyTracker {
      analyzeIngredient(input: $input) {
        ... on AnalyzedDailyTrackerIngredients {
          primaryIngredient {
            productId
            name
            brand
            baseAmount
            baseUnit
            calories
            proteinGrams
            carbsGrams
            fatGrams
          }
        }
        ... on NotFoodError {
          message
          description
        }
        ... on ValidationException {
          validationCode: code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on Error {
          errorCode: code
          name
          description
        }
      }
    }
  }
`;
